import React from 'react';
import { cn } from '../../design-system/cn';
import Card from '../ui/Card';
import { typography } from '../../design-system/tokens';
import PayoutReceipt from '../features/PayoutReceipt';

/**
 * Live review summary for lock creation flows.
 */
export default function LockPreviewCard({
  rows = [],
  stake,
  subscriptionProfile,
  className = '',
}) {
  const amount = Number(stake) || 0;
  const showReceipt = amount > 0;

  return (
    <Card variant="subtle" padding="sm" className={cn('rounded-xl border-emerald-500/25 bg-emerald-500/5 space-y-2 min-w-0 overflow-hidden sm:p-4', className)}>
      <p className={`${typography.microWide} text-emerald-400`}>Your lock</p>
      <div className="space-y-1.5 text-sm min-w-0">
        {rows.map((row) => (
          <div key={row.label} className="flex justify-between gap-2 min-w-0">
            <span className="text-gray-500 font-bold text-xs shrink-0">{row.label}</span>
            <span className={`font-black text-right text-xs min-w-0 break-words ${row.highlight ? 'text-emerald-400' : 'text-white'}`}>
              {row.value}
            </span>
          </div>
        ))}
      </div>
      {showReceipt && (
        <PayoutReceipt
          totalPot={amount * 2}
          stakePerPlayer={amount}
          subscriptionProfile={subscriptionProfile}
          compact
          className="mt-3 border-emerald-500/20"
        />
      )}
    </Card>
  );
}
